import { paperClasses } from '@mui/material/Paper';
import type { Components } from '@mui/material/styles';

import type { Theme } from '../theme/types';

export const MuiDialog = {
  styleOverrides: {
    paper: ({ theme }) => ({
      borderRadius: '20px',
      backgroundImage: 'none',
      [`&.${paperClasses.elevation24}`]: {
        boxShadow:
          theme.palette.mode === 'dark'
            ? '0 5px 22px 0 rgba(0, 0, 0, 0.24)'
            : '0 5px 22px 0 rgba(0, 0, 0, 0.04)',
      },
    }),
    paperWidthXs: {
      maxWidth: 444,
    },
    paperWidthSm: {
      maxWidth: 600,
    },
    paperWidthMd: {
      maxWidth: 900,
    },
    paperWidthLg: {
      maxWidth: 1200,
    },
    paperWidthXl: {
      maxWidth: 1536,
    },
  },
  defaultProps: {
    BackdropProps: {
      sx: {
        backgroundColor: 'var(--mui-palette-Backdrop-bg)',
      },
    },
  },
} satisfies Components<Theme>['MuiDialog'];

export const MuiDialogTitle = {
  styleOverrides: {
    root: {
      padding: '24px 24px 16px',
    },
  },
} satisfies Components<Theme>['MuiDialogTitle'];

export const MuiDialogContent = {
  styleOverrides: {
    root: {
      padding: '24px',
    },
  },
} satisfies Components<Theme>['MuiDialogContent'];

export const MuiDialogActions = {
  styleOverrides: {
    root: {
      padding: '16px 24px 24px',
      gap: 8,
    },
  },
} satisfies Components<Theme>['MuiDialogActions'];
